import { type Styles } from 'react-modal';

export const MODAL_DEFAULT_STYLES: Styles = {
  content: {
    width: '25%',
    height: '25%',
    minWidth: '500px',
    minHeight: '590px',
    padding: '0px',
    borderRadius: '30px',
    border: 'none',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    background: 'rgba(30, 30, 30, 0.3)',
    zIndex: 1000,
  },
};

export const MODAL_CONFIRM_STYLES: Styles = {
  content: {
    width: 'auto',
    height: 'auto',
    minWidth: '440px',
    maxWidth: '520px',
    minHeight: 'auto',
    padding: '0px',
    borderRadius: '24px',
    border: 'none',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    background: 'rgba(30, 30, 30, 0.3)',
    zIndex: 1000,
  },
};

export const MODAL_EDIT_LINK_STYLES: Styles = {
  content: {
    width: '90vw',
    height: '95vh',
    maxWidth: '95vw',
    maxHeight: '100vh',
    minWidth: '480px',
    padding: '0px',
    borderRadius: '24px',
    border: 'none',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  overlay: {
    background: 'rgba(30, 30, 30, 0.3)',
    zIndex: 2000,
  },
};

export const MODAL_REFERENCER_STYLES: Styles = {
  content: {
    width: '25%',
    height: '25%',
    minWidth: '960px',
    minHeight: '590px',
    padding: '0px',
    borderRadius: '30px',
    border: 'none',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    background: 'rgba(30, 30, 30, 0.3)',
    zIndex: 1000,
  },
};

export const MODAL_ADD_LANGUAGE_STYLES: Styles = {
  content: {
    width: '30%',
    height: 'auto',
    minWidth: '640px',
    minHeight: '720px',
    maxHeight: '90vh',
    padding: '0px',
    borderRadius: '30px',
    border: 'none',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  overlay: {
    background: 'rgba(30, 30, 30, 0.3)',
    zIndex: 1000,
  },
};

export const MODAL_ADD_BLOCK_STYLES: Styles = {
  content: {
    width: '32%',
    height: 'auto',
    minWidth: '640px',
    minHeight: '540px',
    maxHeight: '90vh',
    padding: '0px',
    borderRadius: '30px',
    border: 'none',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  overlay: {
    background: 'rgba(30, 30, 30, 0.3)',
    zIndex: 1000,
  },
};

export const MODAL_TABLE_SIZE_STYLES: Styles = {
  content: {
    width: 'auto',
    height: 'auto',
    minWidth: '480px',
    maxWidth: '520px',
    minHeight: 'auto',
    padding: '0px',
    borderRadius: '30px',
    border: 'none',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  overlay: {
    background: 'rgba(30, 30, 30, 0.3)',
    zIndex: 1000,
  },
};
